import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import * as React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';

var Ripple = function (_React$Component) {
    _inherits(Ripple, _React$Component);

    function Ripple() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Ripple);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Ripple.__proto__ || _Object$getPrototypeOf(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            rippleEntering: false,
            wrapperExiting: false
        }, _this.handleEnter = function () {
            _this.setState({
                rippleEntering: true
            });
        }, _this.handleExit = function () {
            _this.setState({
                wrapperExiting: true
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Ripple, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                rippleX = _props.rippleX,
                rippleY = _props.rippleY,
                rippleSize = _props.rippleSize,
                color = _props.color,
                timeout = _props.timeout,
                other = _objectWithoutProperties(_props, ['className', 'rippleX', 'rippleY', 'rippleSize', 'color', 'timeout']);

            var _state = this.state,
                wrapperExiting = _state.wrapperExiting,
                rippleEntering = _state.rippleEntering;


            return React.createElement(
                Transition,
                _extends({
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: timeout
                }, other),
                React.createElement(
                    'span',
                    {
                        className: cn('rtr-ripple-wrapper', {
                            'rtr-ripple-wrapper-exiting': wrapperExiting
                        }, className),
                        style: { animationDuration: timeout.exit + 'ms' }
                    },
                    React.createElement('span', {
                        className: cn('rtr-ripple', {
                            'rtr-ripple-entering': rippleEntering
                        }),
                        style: {
                            width: rippleSize,
                            height: rippleSize,
                            top: rippleY - rippleSize / 2,
                            left: rippleX - rippleSize / 2,
                            backgroundColor: color,
                            animationDuration: timeout.enter + 'ms'
                        }
                    })
                )
            );
        }
    }]);

    return Ripple;
}(React.Component);

export default Ripple;